import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import './ParameterItem.scss';

const ParameterItem = (props) => {
  const {
    index,
    onDelete,
    name,
    nameError,
    onChangeName,
    value,
    valueError,
    onChangeValue,
  } = props;
  const handleDelete = () => {
    onDelete(index);
  };
  const handleChangeName = (evt) => {
    if (onChangeName) onChangeName(index, evt.target.value);
  };
  const handleChangeValue = (evt) => {
    if (onChangeValue) onChangeValue(index, evt.target.value);
  };
  return (
    <div className="grb-batchparameter-item">
      <TextField
        className="grbrsm-batch-parameter-name"
        error={Boolean(nameError)}
        label="Name"
        value={name}
        onChange={handleChangeName}
        helperText={nameError}
        margin="dense"
      />
      <div className="grb-flex" />
      <TextField
        className="grbrsm-batch-parameter-value"
        error={Boolean(valueError)}
        label="Value"
        value={value}
        onChange={handleChangeValue}
        helperText={valueError}
        margin="dense"
      />
      <IconButton aria-label="Delete" size="small" onClick={handleDelete}>
        <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          <path fill="none" d="M0 0h24v24H0z" />
        </svg>
      </IconButton>
    </div>
  );
};

ParameterItem.propTypes = {
  index: PropTypes.number.isRequired,
  name: PropTypes.string,
  nameError: PropTypes.string,
  onChangeName: PropTypes.func,
  value: PropTypes.string,
  valueError: PropTypes.string,
  onChangeValue: PropTypes.func,
  onDelete: PropTypes.func,
};

ParameterItem.defaultProps = {
  name: '',
  nameError: undefined,
  onChangeName: undefined,
  value: '',
  valueError: '',
  onChangeValue: undefined,
  onDelete: undefined,
};

export default ParameterItem;
